import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { DeviceGroup_Interface } from 'src/app/Interface/DeviceGroup_Interface';
import { General_Interface } from 'src/app/Interface/General_Interface';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DeviceGroupService {

  constructor(private http:HttpClient) { }


  GetRecord1(Token:String,id:number):Observable<Array<General_Interface>>{
    return this.http.get(environment.BaseUrl + "Daro/DeviceGroup?token="+Token+"&id="+id).pipe(
      map(data=>{
        return data as Array<General_Interface>
      })
    )
  }

  GetTree(Token:String):Observable<Array<DeviceGroup_Interface>>{
    return this.http.get(environment.BaseUrl + "Daro/DeviceGroup/GetTree?token="+Token).pipe(
      map(data=>{
        return data as Array<DeviceGroup_Interface>
      })
    )
  }

  GetDeviceGroup(Token:String,Parent:number):Observable<Array<General_Interface>>{
    return this.http.get(environment.BaseUrl + "Daro/DeviceGroup/GetDeviceGroup?token="+Token+"&parent="+Parent).pipe(
      map(data=>{
        return data as Array<General_Interface>
      })
    )
  }


  EditAddDeviceGroup(model: DeviceGroup_Interface,Token:String):Observable<DeviceGroup_Interface>{
    const headers = new HttpHeaders().set('content-type', 'application/json');


    var body = {
      id:model.id,
      title:model.title,
      parent:model.parent,
      pm_program_id:model.pm_program_id,
      del:false,
      username:Token,
      subdate:null
    }


      return this.http.post(environment.BaseUrl + "Daro/DeviceGroup/AddEdit",body,{headers}).pipe(
        map(data=>{
          return data as DeviceGroup_Interface
        })
      )

  }

  DeleteDeviceGroup(id:number,Token:String):Observable<DeviceGroup_Interface>{

      return this.http.get(environment.BaseUrl + "Daro/DeviceGroup/Delete?id="+id+"&token="+Token).pipe(
        map(data=>{
          return data as DeviceGroup_Interface
        })
      )
  }

  UncountableDeviceGroup(id:number,Token:String):Observable<DeviceGroup_Interface>{

    return this.http.get(environment.BaseUrl + "Daro/DeviceGroup/Uncountable?id="+id+"&token="+Token).pipe(
      map(data=>{
        return data as DeviceGroup_Interface
      })
    )

  }

}
